export default __webpack_public_path__ + "static/media/zip11.3a2ad63e.png";